import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Stopwatch = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15.707 16.293C15.888 16.474 16 16.724 16 17C16 17.552 15.552 18 15 18C14.724 18 14.474 17.888 14.293 17.707L10.293 13.707C10.112 13.526 10 13.276 10 13C10 12.448 10.448 12 11 12C11.276 12 11.526 12.112 11.707 12.293L15.707 16.293Z" />
		<path d="M27.707 8.293L23.707 4.293C23.526 4.112 23.276 4 23 4C22.448 4 22 4.448 22 5C22 5.276 22.112 5.526 22.293 5.707L23.586 7L22.035 8.551C20.127 6.959 17.673 6 15 6C14.448 6 14 6.448 14 7V9C14 9.552 14.448 10 15 10C15.552 10 16 9.552 16 9V8.057C20.165 8.52 23.48 11.835 23.943 16H23C22.448 16 22 16.448 22 17C22 17.552 22.448 18 23 18H23.943C23.48 22.165 20.165 25.48 16 25.943V25C16 24.448 15.552 24 15 24C14.448 24 14 24.448 14 25V25.943C9.507 25.444 6 21.624 6 17C6 16.448 5.552 16 5 16C4.448 16 4 16.448 4 17C4 23.065 8.935 28 15 28C21.065 28 26 23.065 26 17C26 14.327 25.041 11.873 23.449 9.965L25 8.414L26.293 9.707C26.474 9.888 26.724 10 27 10C27.552 10 28 9.552 28 9C28 8.724 27.888 8.474 27.707 8.293V8.293Z" />
	</svg>
);

export default Stopwatch;
